import React from "react";
import { GlobalStyles } from "@mui/material";
import { Theme } from "@mui/material/styles";

interface DateRangeGlobalStylesProps {
  theme: Theme;
}

const DateRangeGlobalStyles: React.FC<DateRangeGlobalStylesProps> = ({
  theme,
}) => {
  return (
    <GlobalStyles
      styles={{
        ".rdrCalendarWrapper": {
          backgroundColor: `${theme.palette.background.paper} !important`,
          color: `${theme.palette.text.primary} !important`,
        },
        ".rdrMonthAndYearWrapper": {
          backgroundColor: `${theme.palette.background.paper} !important`,
          color: `${theme.palette.text.primary} !important`,
        },
        ".rdrMonthAndYearPickers": {
          color: `${theme.palette.text.primary} !important`,
        },
        ".rdrWeekDays": {
          backgroundColor: `${theme.palette.background.paper} !important`,
        },
        ".rdrWeekDay": {
          color: `${theme.palette.text.secondary} !important`,
        },
        ".rdrDays": {
          backgroundColor: `${theme.palette.background.paper} !important`,
        },
        ".rdrDay": {
          color: `${theme.palette.text.primary} !important`,
          backgroundColor: `${theme.palette.background.paper} !important`,
        },
        ".rdrDay:hover": {
          backgroundColor: `${theme.palette.action.hover} !important`,
        },
        ".rdrDayNumber": {
          color: `${theme.palette.text.primary} !important`,
        },
        ".rdrDayNumber span": {
          color: `${theme.palette.text.primary} !important`,
        },
        ".rdrDay.rdrDayToday .rdrDayNumber span:after": {
          backgroundColor: `${theme.palette.primary.main} !important`,
        },
        ".rdrDay.rdrDayToday .rdrDayNumber": {
          color: `${theme.palette.text.primary} !important`,
        },
        ".rdrDay.rdrDayPassive": {
          color: `${theme.palette.text.disabled} !important`,
        },
        ".rdrDay.rdrDayPassive .rdrDayNumber": {
          color: `${theme.palette.text.disabled} !important`,
        },
        ".rdrDay.rdrDayDisabled": {
          color: `${theme.palette.text.disabled} !important`,
        },
        ".rdrDay.rdrDayDisabled .rdrDayNumber": {
          color: `${theme.palette.text.disabled} !important`,
        },
        ".rdrMonthAndYearWrapper button": {
          color: `${theme.palette.text.primary} !important`,
        },
        ".rdrMonthAndYearPickers select": {
          color: `${theme.palette.text.primary} !important`,
        },
        ".rdrMonthAndYearPickers button": {
          color: `${theme.palette.text.primary} !important`,
        },
      }}
    />
  );
};

export default DateRangeGlobalStyles;
